import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { useLicenseEntitlementLimit } from '#layers/access/public';

/**
 * Route-level backstop for the workspace-create page. The create button already guards, but the
 * page is directly reachable by URL/back-button, so a hard-blocked user could bypass the button.
 * Redirect to the organization dashboard when workspaces are hard-blocked. Soft limits stay
 * reachable (creation is still allowed). `workspaces` is an org entitlement, so enforce against
 * org-wide usage regardless of the active workspace.
 */
export default defineNuxtRouteMiddleware(async () => {
	const { isCreationBlocked } = useLicenseEntitlementLimit({ scope: 'system' });
	if (await isCreationBlocked('workspaces')) return '/~/organization/workspaces';
});
